/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Scope_Needs_PermissionInputs */

const en_views_scope_needs_permission = /** @type {(inputs: Views_Scope_Needs_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need the Share views permission on this product.`)
};

const de_views_scope_needs_permission = /** @type {(inputs: Views_Scope_Needs_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dafür brauchst du die Berechtigung Ansichten teilen in diesem Produkt.`)
};

/**
* | output |
* | --- |
* | "You need the Share views permission on this product." |
*
* @param {Views_Scope_Needs_PermissionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_scope_needs_permission = /** @type {((inputs?: Views_Scope_Needs_PermissionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Scope_Needs_PermissionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_scope_needs_permission(inputs)
	return en_views_scope_needs_permission(inputs)
});